import axios from 'axios'
import { host } from '../../configuraciones'
import {createAsyncThunk,createSlice} from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {
        data:[]
    }
}
//types
const OBTENER_DATOS_PREDIO_HISTORICO_EXITO= 'OBTENER_DATOS_PREDIO_HISTORICO_EXITO'
const AGREGAR_DATOS_PREDIO_HISTORICO_EXITO= 'AGREGAR_DATOS_PREDIO_HISTORICO_EXITO'

const ACTUALIZAR_DATOS_PREDIO_HISTORICO_EXITO= 'ACTUALIZAR_DATOS_PREDIO_HISTORICO_EXITO'


export const obtenerAllDatosPredioHistorico = createAsyncThunk(
    OBTENER_DATOS_PREDIO_HISTORICO_EXITO,
    async () => {
        try {
            const fullUrl = host + `DatosPredioHistorico/obtenerAllDatosPredioHistorico`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarDatosPredioHistorico = createAsyncThunk(
    AGREGAR_DATOS_PREDIO_HISTORICO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DatosPredioHistorico/agregarDatosPredioHistorico`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizarDatosPredioHistorico = createAsyncThunk(
    ACTUALIZAR_DATOS_PREDIO_HISTORICO_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DatosPredioHistorico/actualizarDatosPredioHistorico`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)



export const datosPredioHistoricoSlice = createSlice({
    name: 'datosPredioHistoricoSlice',
    initialState: dataInicial,
    reducers: {
       
    },
    extraReducers: {
      
        [obtenerAllDatosPredioHistorico.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            
        },
        [agregarDatosPredioHistorico.fulfilled]: (state, { payload }) => {
         
        },

        [actualizarDatosPredioHistorico.fulfilled]: (state, { payload }) => {
       
        },
    },
})

export const {
} = datosPredioHistoricoSlice.actions
export const DatosPredioHistoricoReducerUsuarioAgricola = datosPredioHistoricoSlice.reducer
